import Loading from './Loading';
const Loader = ({
  className
}: {
  className?: string;
}) => {
  return <div className={`flex absolute top-[100px] left-0 w-full h-full justify-center items-center ${className && className}`} data-sentry-component="Loader" data-sentry-source-file="Loader.tsx">
      <Loading data-sentry-element="Loading" data-sentry-source-file="Loader.tsx" />
    </div>;
};
export default Loader;